import { X, MessageCircle } from "lucide-react";

/**
 * MockPaymentModal — Genérico para los flows MOCK (compra de vino + suscripción de bodega).
 * No procesa tarjetas. Solo confirma intención y deriva a WhatsApp.
 */
export default function MockPaymentModal({ title, subtitle, amount, currency = "USD", body, onClose, testId = "mock-modal" }) {
    return (
        <div className="fixed inset-0 z-50 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4" data-testid={testId}>
            <div className="bg-[#0A0A0A] border border-[#27272A] max-w-lg w-full">
                <div className="flex items-start justify-between p-8 border-b border-[#27272A]">
                    <div>
                        <p className="overline mb-2">{title}</p>
                        <p className="font-display text-3xl text-[#C9A961]">{currency} {Number(amount).toLocaleString("en-US")}</p>
                        {subtitle && <p className="text-sm text-[#A1A1AA] mt-2">{subtitle}</p>}
                    </div>
                    <button onClick={onClose} className="text-[#71717A] hover:text-white" data-testid={`${testId}-close`}><X className="w-5 h-5" /></button>
                </div>

                <div className="p-8 space-y-6">
                    <div className="flex items-start gap-3 border-l-2 border-[#C9A961] pl-4">
                        <MessageCircle className="w-5 h-5 text-[#C9A961] shrink-0 mt-0.5" />
                        <p className="text-base text-[#E4E4E7] leading-relaxed">
                            {body || "Gracias. Te contactamos por WhatsApp para coordinar la transferencia bancaria. El equipo de CellarGlobal te escribe en menos de 24hs."}
                        </p>
                    </div>
                    <button onClick={onClose} className="btn-gold w-full" data-testid={`${testId}-ok`}>Entendido</button>
                </div>
            </div>
        </div>
    );
}
